



class CartDrawer extends HTMLElement {
  constructor() {
    super();
      
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#head-cart-count');
    cartLink.setAttribute('role', 'button');

    if( window.location.pathname != routes_cart_url ){
        cartLink.setAttribute('aria-haspopup', 'dialog');
    
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');


    openProtectionPopupInDrawerCart()
    checkDoscuntLabelInAppTotalsDrawers();
   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
   
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          
    }));

    
    openProtectionPopupInDrawerCart()
    promocodeSlideToggle()
    checkDoscuntLabelInAppTotalsDrawers();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      
      
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
      
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
      
  }

  setActiveElement(element) {
    this.activeElement = element;
    
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


 
//show popup when click button in drawr cart
function openProtectionPopupInDrawerCart(){

  if(document.querySelectorAll('.protection-btn-cart[data-popup]').length > 0){
    const buttonsDrawerpopuop = document.querySelectorAll('.protection-btn-cart[data-popup]');
   
    buttonsDrawerpopuop.forEach(button => {
        button.addEventListener('click', function(e) {
        
          e.preventDefault();
        
          const popupfromDrawer = document.querySelector(`.protection-plan-popup[id="${this.dataset.popup}"]`);
          if (popupfromDrawer) {
         
            popupfromDrawer.classList.add('active'); 

             //current qunatity
           
            popupfromDrawer.querySelector('.quantity__input[name="quantity"]').value = document.querySelector(`.cart-item[data-id="${this.dataset.itemid}"] .quantity__input`).value;
           
            
          }
        });
      });

  }




  /*fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log(cart)
    })*/

      if(document.querySelectorAll('.cart-items .protection_plan_message').length > 0){
        document.querySelectorAll('.cart-items .protection_plan_message').forEach(item=>{
          setTimeout(function() {
             
              item.style.display = 'block';
          }, 500);
        })
      }


}


function applayDoscountAppButton(){
  setTimeout(() => {
    
    
      if(document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove').length > 0){
   
        document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove').forEach(item=>{
    
          item.addEventListener('click', function(){
        
            checkDoscuntLabelInAppTotalsDrawers()
          })
        })
      }

    },3000)

}applayDoscountAppButton()


function promocodeSlideToggle(){
  
  if(document.querySelectorAll('.js-promo-box-slide').length > 0){
    document.querySelector('.js-promo-box-slide').addEventListener('click', function(){
      this.classList.toggle('active');
    });
  }

  setTimeout(() => {
    

    if(document.querySelectorAll('.docapp-coupon-input--input-container .docapp-coupon-input--button').length > 0){
 
      document.querySelector('.docapp-coupon-input--input-container .docapp-coupon-input--button').addEventListener('click', function(){
        
        applayDoscountAppButton()
        checkDoscuntLabelInAppTotalsDrawers()
       
      })            
    }
  },1000)
  


}promocodeSlideToggle()



function checkDoscuntLabelInAppTotalsDrawers(){

  setTimeout(() => {
      if(document.querySelectorAll('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary').length > 0){
            
            console.log('doctor discount app totals drawer')
            
              document.querySelector('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary').classList.add('loaded-app')
              const summaryElement = document.querySelector('.cart-drawer__footer .docapp-cart-with-coupon-summary--summary');

                if (summaryElement.querySelector('.docapp-cart-discount')) {
                  summaryElement.classList.add('has-discount');
                  var totlasavingValue = summaryElement.querySelector('.docapp-cart-discount .docapp-right');
                  summaryElement.querySelector('.docapp-cart-discount .docapp-left').innerHTML = 'Total Savings';
                  totlasavingValue.textContent = totlasavingValue.textContent.replace('', '');
                } else {
                  summaryElement.classList.remove('has-discount');
                }


             

        }



  },3000)

}


function getDataCart(){

  fetch('/cart.js')
    .then(response => {
      return response.json();
    })
    .then(data => {
      //console.log('>>>>>>>>>>>>>>>>')
      console.log(data)
      
      getInnerProductsObjectsArray(data)
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}getDataCart()


function getInnerProductsObjectsArray(data) {
  const innerProducts = [];

  // Get parent purifier items that have inner subscription products
  data.items.forEach((item) => {
    if (item.properties && item.properties._inner_products) {
      let innerProductIds = [];

      try {
        innerProductIds = JSON.parse(item.properties._inner_products);
      } catch (e) {
        console.error('Invalid _inner_products JSON:', item.properties._inner_products);
      }

      innerProducts.push({
        parent_id: item.id,
        parent_key: item.key,
        bundle_uid: item.properties._subscription_bundle_uid || '',
        inner_products: innerProductIds
      });
    }
  });

  if (innerProducts.length === 0) return;

  // Hide actual child subscription cart lines by cart line key
  data.items.forEach((item) => {
    if (
      item.properties &&
      item.properties._subscription_child === 'true'
    ) {
      const childCartItem = document.querySelector(
        `.cart-items .cart-item[data-key="${CSS.escape(item.key)}"]`
      );

      if (childCartItem) {
        childCartItem.style.display = 'none';
      }
    }
  });

 
// Build inner subscription products under the correct parent only
innerProducts.forEach((parent) => {
  const foundItems = data.items.filter((child) => {
    const matchesInnerProduct =
      parent.inner_products.some(
        (innerId) => Number(innerId) === Number(child.id)
      );

    if (!matchesInnerProduct) return false;

    const childBundleUid =
      child.properties?._subscription_bundle_uid || '';

    const isTaggedChild =
      child.properties?._subscription_child === 'true';

    // New bundle: only use children from the same bundle
    if (parent.bundle_uid) {
      return (
        isTaggedChild &&
        childBundleUid === parent.bundle_uid
      );
    }

    // Old bundle: only use untagged children
    return !isTaggedChild && !childBundleUid;
  });

    const innerProductsContainer = document.querySelectorAll(
      `.cart-items .cart-item[data-key="${CSS.escape(parent.parent_key)}"]`
    );

    if (innerProductsContainer.length > 0) {
      innerProductsContainer.forEach((container) => {
        if (!container.dataset.innerproducts) return;

        const fragmentElement = document.createDocumentFragment();

        foundItems.forEach((item) => {
          const innerProductDiv = document.createElement("div");
          innerProductDiv.classList.add("inner-product");
          innerProductDiv.classList.add("js-inner-product");
          innerProductDiv.setAttribute("data-key", item.key);
          innerProductDiv.setAttribute("data-id", item.id);

          innerProductDiv.innerHTML = `
            <div class="cart-inner-product-img">
              <img src="${item.featured_image?.url || ''}" width="80" alt="">
            </div>
            <div class="cart-inner-product-title-price">
              <div class="cart-inner-product-title">${item.product_title}</div>
                
              <div class="cart-inner-product-details">
                First payment $0, then <span>${item.selling_plan_allocation?.selling_plan?.name ?? ''}</span>
                <span class="cart-sale-price">${getProductJsDate(item.handle)}</span>
              </div>
              
              <div class="cart-inner-product-price">$${item.price}</div>
            </div>
            <div class="remove-element js-remove-inner-product" data-key="${item.key}">
              Remove
            </div>
          `;

          fragmentElement.appendChild(innerProductDiv);
        });

        const innerWrapper = container.querySelector('.js-inner-products');

        if (innerWrapper) {
          innerWrapper.innerHTML = '';
          innerWrapper.appendChild(fragmentElement);
        }
      });
    }
  });

  // Remove individual child subscription by cart line key, not variant ID
  const getInnerProductRemove = document.querySelectorAll('.js-remove-inner-product');

  if (getInnerProductRemove.length > 0) {
    getInnerProductRemove.forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();

        const lineKey = e.target.dataset.key;

        if (!lineKey) return;

        let updates = {
          [lineKey]: 0
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          if (response.ok) {
            document.querySelectorAll(
              `.js-inner-product[data-key="${CSS.escape(lineKey)}"]`
            ).forEach(item => {
              item.remove();
            });

            return response.json();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          cartItemCount();
          checkDoscuntLabelInAppTotalsDrawers();
        });
      });
    });
  }
}

function getProductJsDate(url){
const bundleProducts = [
  {
    'bundle': 'parts-subscription-bundle-pre-filter',
    'price': '$35.99 <s>$39.99</s>',
  },
  {
    'bundle': 'parts-subscription-bundle-recharge-cell',
    'price': '$143.99 <s>$159.99</s>',
  },
  {
     'bundle': 'parts-subscription-bundle-core-750-lamp-kit',
      'price': '$35.99 <s>$39.99</s>',
    },
  {
      'bundle': 'parts-subscription-bundle-core-750-filter',
      'price': '$89.99 <s>$99.99</s>',
    }
  ]

return  (bundleProducts.find(item => item.bundle === url) || {}).price || '';

}

(function watchCartChangesAndRefreshDrawerOnly() {
  let lastCartSignature = null;
  let isRefreshingDrawer = false;

 function getCartSignature(cart) {
  return [
    cart.total_price,
    cart.total_discount
  ].join('::');
}

  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  function refreshCartDrawerOnly() {
  return fetch(window.location.pathname + '?sections=cart-drawer')
    .then(response => response.json())
    .then(sections => {
      const html = sections['cart-drawer'];

      if (!html) return;

     const parser = new DOMParser();
const doc = parser.parseFromString(html, 'text/html');


/* Refresh top product title and prices for every parent item */
const newTopPrices = doc.querySelectorAll(
  '.cart-item:not([data-subscription-child="true"]) .drawer-item-heading'
);

const currentTopPrices = document.querySelectorAll(
  'cart-drawer .cart-item:not([data-subscription-child="true"]) .drawer-item-heading'
);

newTopPrices.forEach((newTopPrice, index) => {
  const currentTopPrice = currentTopPrices[index];

  if (newTopPrice && currentTopPrice) {
    currentTopPrice.replaceWith(newTopPrice);
  }
});

/* Refresh footer */
const newFooter = doc.querySelector('.cart-drawer__footer');
const currentFooter = document.querySelector(
  'cart-drawer .cart-drawer__footer'
);

if (newFooter && currentFooter) {
  currentFooter.replaceWith(newFooter);
}

if (typeof checkDoscuntLabelInAppTotalsDrawers === 'function') {
  checkDoscuntLabelInAppTotalsDrawers();
}
})
.catch(error => {
  console.error('Cart summary refresh error:', error);
});
}

  function checkCartForChanges() {
    if (isRefreshingDrawer) return;

    getCart()
      .then(cart => {
        const currentSignature = getCartSignature(cart);

        if (lastCartSignature === null) {
          lastCartSignature = currentSignature;
          return;
        }

        if (currentSignature !== lastCartSignature) {
          lastCartSignature = currentSignature;
          isRefreshingDrawer = true;

          console.log('Cart changed — refreshing drawer only');

          refreshCartDrawerOnly().finally(() => {
            setTimeout(() => {
              isRefreshingDrawer = false;
            }, 800);
          });
        }
      })
      .catch(error => {
        console.error('Cart watcher error:', error);
      });
  }

  setInterval(checkCartForChanges, 800);
})();